import React, { useState, useEffect } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";
import { API_TOKEN_NAME } from "../../constants";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import Pagination from "react-js-pagination";

const getAllVideoGalleries = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/videogallery/get", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const VideoGallery = () => {
  const [galleries, setGalleries] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 6;

  const refreshGallery = () => {
    getAllVideoGalleries()
      .then((res) => {
        if (res.status === true) {
          setGalleries(res.data);
          setTotalItems(res.data.length);
        } else {
          setGalleries([]);
          setTotalItems(0);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    refreshGallery();
  }, []);

  // Calculate current items based on active page
  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = galleries.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  return (
    <div>
      <SEO
        title={
          "Video Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh"
        }
        description={"Photo Gallery of United Hospital Bangladesh Limited"}
        pathSlug="/gallery/photo-gallery"
        keywords="newsevents, Singlenewsevents"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody pb-2">
          <div className="container p-3">
            <div className="w-100 d-flex justify-content-center align-items-center flex-column py-3">
              <h3
                className="text-center"
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                Video Gallery
              </h3>
            </div>
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 w-100 mx-auto">
              {currentItems.length > 0 ? (
                currentItems.map((gallery, index) => (
                  <div className="col" key={index}>
                    <div className="card p-3 h-100">
                      <div className="card-body  d-flex flex-column justify-content-between align-items-start">
                        <h5 className="card-title">
                          {gallery.video_gallery_name}
                        </h5>
                        <iframe
                          width={"100%"}
                          height="300"
                          src={gallery.video_gallery_desc.replace(
                            /^<p>|<\/p>$/g,
                            ""
                          )}
                          title="Video"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No videos available.</p>
              )}
            </div>
            {/* Pagination Controls */}
            {totalItems > itemsPerPage && (
              <div className="pagination-controls d-flex justify-content-center mt-3">
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={totalItems}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </section>
      </div>
      <Route component={Footer} />
    </div>
  );
};

export default VideoGallery;



// WEBPACK FOOTER //
// ./src/component/frontend/VideoGallery.js